/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteSearchRequest = {
    filterBy?: KiteSearchRequest.filterBy;
    term: string;
};

export namespace KiteSearchRequest {

    export enum filterBy {
        ALL = 'ALL',
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        TOKEN = 'TOKEN',
    }


}

